import { Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { filter, Subscription } from 'rxjs';
import { AppUtils } from 'src/app/core/app-utils';
import { DateUtils } from 'src/app/core/date-utils';
import { DebitCardDTO } from 'src/app/core/models/card';
import { CompanyLogoDTO, CompanySettingDTO, CompanyUniversityCalendarDTO } from 'src/app/core/models/company';
import { MemberContactDTO, MemberDTO } from 'src/app/core/models/member';
import { CartDetailDTO } from 'src/app/core/models/shopping-cart';
import { CardService } from 'src/app/core/services/card.service';
import { CompanyService } from 'src/app/core/services/company.sevice';
import { MemberService } from 'src/app/core/services/member.service';
import { AuthService } from 'src/app/core/services/shared-services/auth.service';
import { MessageService } from 'src/app/core/services/shared-services/message.service';
import { NotificationService } from 'src/app/core/services/shared-services/notification.service';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import { dateFormat, TpaCompanyId } from '../../app.constants';
import { OrderTypeEnum } from '../../app.enums';
import { AlertModalComponent } from '../../modal/alert-modal/alert-modal.component';
import { HelpModalComponent } from '../../modal/help-modal/help-modal.component';
import { NotificationComponent } from '../../modal/notification/notification.component';
import { UserDetailModalComponent } from '../../modal/user-detail-modal/user-detail-modal.component';

@Component({
  selector: 'eb-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  @ViewChild('globalErrorContainer', { static: true, read: ViewContainerRef }) errorContainer: ViewContainerRef;
  message: string = 'Click!';
  isClicked: boolean = false;
  modalRef: any | MdbModalRef<any>;
  userEmail!: string;
  userGUID!: string;
  userFName!: string;
  userCompanyName!: string;
  userIsEdenRedAdmin = false;
  actingOnLabel = 'Acting On';
  selectedCompanyName: any = '';
  selectedCompany: any;
  selectedCompanyCode: any = '';
  chooseCompanyLabel = 'Select a Company';
  isCustomerPortalVisible: boolean = false;
  hasCstmrPrtlAccess: boolean = false;
  previousUrl: string = '';
  companySettingsData: CompanySettingDTO | undefined;
  fullDate: string = '';
  fullName: string = '';
  isAuthenticated: boolean = false;
  @Input() unreadAlertCount: number = 0;
  @Input() isCardMenu: boolean = false;
  @Input() isElectBenefitMenu: boolean = false;
  @Input() isMarketMenu: boolean = false;
  @Input() isClaimMenu: boolean = false;
  @Input() isParkingMenu: boolean = false;
  @Input() isMarketPlaceMenu: boolean = false;
  @Input() isDashboardMenu: boolean = false;
  isReserveParking: boolean = false;
  isNavBarVisible = false;
  cartProductsCount = 0;
  companySubscription: Subscription;
  cardSubscription: Subscription;
  shoppingCartSubscription: Subscription;
  memberSubscription: Subscription;
  logoUrl = '';
  isTrnPrkPCCCAllow: boolean;
  notificationList: any;
  activeNotificationCount = 0;
  amazonNotEligible = false;
  isAmznDiffLocation = false;
  isLSARole: boolean;
  isCRRole: boolean;
  isTrRole: boolean;
  isOrcaRole: boolean;
  hideElectBenefits = false;
  memberSettings: MemberDTO;
  pptIsSuspended = false;
  isUserAllowedToOrder = false;
  isBlueBadgeEmp = false;
  memberContact: MemberContactDTO;
  preferredFirstName = '';
  isBostonUniversity = false;
  unvCompany: CompanyUniversityCalendarDTO;
  pleaseComeBack: boolean = false;
  isStudentRole = false;
  isCHLA = false;
  hadOrders = false;
  hadClaims = false;
  hasActiveCard = false;
  constructor(
    private modalService: MdbModalService,
    private router: Router,
    private messageService: MessageService,
    private authService: AuthService,
    private companyService: CompanyService,
    private cardService: CardService,
    private shoppingCartService: ShoppingCartService,
    private notificationService: NotificationService,
    private memberService: MemberService
  ) {
    this.messageService.activeObservable$.subscribe((res: any) => {
      if (res.refresh) {
        this.isReserveParking = res.refresh;
      }
    });
    this.router.events.pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd)).subscribe(event => {
      if (event.url.includes('elect-benefits')) {
        this.isElectBenefitMenu = true;
        this.isDashboardMenu = false;
        this.isCardMenu = false;
        this.isClaimMenu = false;
      } else if (event.url.includes('dashboard')) {
        this.isElectBenefitMenu = false;
        this.isDashboardMenu = true;
        this.isCardMenu = false;
        this.isClaimMenu = false;
      } else if (event.url.includes('card')) {
        this.isElectBenefitMenu = false;
        this.isDashboardMenu = false;
        this.isCardMenu = true;
        this.isClaimMenu = false;
      } else if (event.url.includes('claim')) {
        this.isElectBenefitMenu = false;
        this.isDashboardMenu = false;
        this.isCardMenu = false;
        this.isClaimMenu = true;
      } else {
        this.isElectBenefitMenu = false;
        this.isDashboardMenu = true;
        this.isCardMenu = false;
        this.isClaimMenu = false;
      }
    });
  }

  ngOnInit(): void {
    this.isUserAllowedToOrder = AppUtils.isUserAllowedToOrder();
    this.isLSARole = AppUtils.isInRoles('LsaRole');
    this.isCRRole = AppUtils.isInRoles('CRRole');
    this.isTrRole = AppUtils.isInRoles('TRRole');
    this.isOrcaRole = AppUtils.isInRoles('OrcaRole');
    if (AppUtils.isInRoles('StudentRole')) {
      this.isStudentRole = true;
    } else {
      this.isStudentRole = false;
    }
    this.notificationService.globalTargetElement = this.errorContainer;
    this.isAuthenticated = this.authService.isAuthenticated;
    this.fullName = this.authService.getFullname();

    if (this.isAuthenticated) {
      this.getMemberSettings();

      this.cardSubscription = this.cardService.cards$.subscribe((cards: DebitCardDTO[]) => {
        this.hasActiveCard = (cards ?? []).some(card => card?.statusDescription === 'Active');
      });

      this.shoppingCartSubscription = this.shoppingCartService.tempCartProductsCount$.subscribe(res => {
        this.cartProductsCount = res;
      });

      this.memberService.markAsReadNotification$.subscribe(res => {
        if (res) {
          this.loadMemberNotifications();
        }
      });
    }
  }
  loadMemberNotifications(): void {
    this.memberSubscription = this.memberService
      .getMemberNotifications(AppUtils.memberId, this.companySettingsData.idTpa, this.companySettingsData.idCompany)
      .subscribe(resp => {
        if (resp) {
          this.notificationList = resp;
          this.activeNotificationCount = this.notificationList.filter(x => !x.isReadByMember).length;
          if (this.notificationList.length > 0) {
            this.notificationList.forEach(element => {
              element.publishDate = DateUtils.FromUnix(element.publishDate);
              element.expiryDate = DateUtils.FromUnix(element.expiryDate);
              const initialSubject = element.body.replace(/&nbsp;/g, ' ').split(' ');
              if (initialSubject.length > 0) {
                element.body = initialSubject.join(' ');
              }
            });

            this.notificationService.setNotificationData = this.notificationList;
          }
        }
      });
  }
  navigateToPage(item: any) {
    switch (item) {
      case 'Dashboard': {
        if (AppUtils.appRoles && AppUtils.appRoles.length > 0) {
          if (AppUtils.appRoles.indexOf('LsaRole') > -1) {
            this.router.navigateByUrl('/dashboard/lsa');
          } else {
            this.router.navigateByUrl('/dashboard/home');
          }
        } else {
          this.router.navigateByUrl('/dashboard/home');
        }
        break;
      }
      case 'Cards': {
        this.router.navigateByUrl('/card/home');
        break;
      }
      case 'ElectBenefits': {
        this.router.navigateByUrl('/elect-benefits/home');
        break;
      }
      case 'Claims': {
        this.router.navigateByUrl('/claim/home');
        break;
      }
      case 'Market Place': {
        this.router.navigateByUrl('/marketplace/marketplace');
        break;
      }
      case 'Parking': {
        this.router.navigateByUrl('/parking/parking');
        break;
      }
      default: {
        //statements;
        break;
      }
    }
  }

  showAlertPopup() {
    this.modalRef = this.modalService.open(AlertModalComponent, {
      data: {},
      modalClass: 'modal-help modal-dialog modal-fullscreen-lg-down modal-alert',
    });
    this.modalRef.onClose.subscribe((message: string) => {
      if (message == 'MarkApplicationComplete') {
      }
    });
  }
  showUserDetailPopup() {
    this.modalRef = this.modalService.open(UserDetailModalComponent, {
      data: {},
      modalClass: 'modal-help modal-dialog modal-fullscreen-lg-down messageModal',
    });
    this.modalRef.onClose.subscribe((message: string) => {
      if (message == 'MarkApplicationComplete') {
      }
    });
  }
  showHelpMenuPopup() {
    this.modalRef = this.modalService.open(HelpModalComponent, {
      data: {},
      modalClass: 'modal-help modal-circle modal-dialog modal-fullscreen-lg-down messageModal',
    });
    this.modalRef.onClose.subscribe((message: string) => {
      if (message == 'MarkApplicationComplete') {
      }
    });
  }
  showNotificationPopup() {
    this.modalRef = this.modalService.open(NotificationComponent, {
      // data: { notificationList: this.notificationList },
      modalClass: 'modal-help modal-circle modal-dialog modal-fullscreen-lg-down messageModal',
    });
    this.modalRef.onClose.subscribe((message: string) => {
      if (message == 'MarkApplicationComplete') {
      }
    });
  }
  openProfileMenu() {
    //this.modalRef = this.modalService.open(ProfileMenuComponent, {
    //  data: {
    //    userFName: this.userFName,
    //    userCompanyName: this.userCompanyName,
    //    userGUID: this.userGUID
    //  },
    //  ModalCssClass: 'menu-modal',
    //  ignoreBackdropClick: false
    //});
  }

  openHelpMenu() {
    //this.modalRef = this.modalService.open(HelpMenuComponent, {
    //  data: {
    //  },
    //  ModalCssClass: 'menu-modal',
    //  ignoreBackdropClick: false
    //});
  }

  openAlertsMenu() {}

  isCustomerPortal() {}
  loadUNVComeBackBanner(companyId: number): void {
    this.companyService
      .getCompanyNextProductCalendar(companyId)
      .subscribe((unvCompanyCalendar: CompanyUniversityCalendarDTO) => {
        if (unvCompanyCalendar) {
          this.unvCompany = unvCompanyCalendar;
          if (this.unvCompany.idProduct > 0) {
            this.pleaseComeBack = true;
          }
        }
      });
  }
  getCompanySettingsData(): void {
    this.companySubscription = this.companyService.companySettings$?.subscribe(
      (companySettingsData: CompanySettingDTO) => {
        if (companySettingsData) {
          this.companySettingsData = companySettingsData;
          this.isTrnPrkPCCCAllow = this.companyService.isTrnPrkPCCCAllow;
          const lastChanceToOrderDate = new Date(this.companySettingsData.lastChanceToOrder);
          this.fullDate = DateUtils.getFormattedDate(lastChanceToOrderDate, dateFormat.MMDDYYYY);
          if (this.companySettingsData?.pptIsAllowUpdatePreferredName) {
            this.loadContactInfo();
          }
          this.getCompanyLogo(this.companySettingsData.idCompany, this.companySettingsData.idTpa);
          this.loadMemberNotifications();
          if (this.isLSARole || this.isTrRole) {
            if (this.companySettingsData?.tpaCompanyId === 'ROTC') {
              this.isNavBarVisible = true;
            } else {
              this.isNavBarVisible = false;
            }
          } else {
            this.isNavBarVisible = true;
          }
          if (this.isLSARole) {
            this.hideElectBenefits = true;
          }

          if (this.companySettingsData?.tpaCompanyId === TpaCompanyId.Amazon) {
            // Check if the member is eligible for Amazon benefits(Routing to Not Eligible page if not eligible - handling through auth guard)
            const amazonEligibility = AppUtils.getAmazonEligibilityContext(
              this.memberSettings,
              this.companySettingsData
            );

            const shouldBlockNavigation = amazonEligibility.shouldRedirectToNotEligible;

            this.amazonNotEligible = shouldBlockNavigation;

            // Condition to check if user has claims only role.
            if (!shouldBlockNavigation && !this.memberSettings?.trnIsAllow && !this.memberSettings?.prkIsAllow) {
              if (this.isCRRole) {
                this.isAmznDiffLocation = true;
              }
            }
          } else {
            this.amazonNotEligible = false;
          }
          if (this.isStudentRole && this.companySettingsData?.tpaCompanyId !== 'DCE') {
            this.loadUNVComeBackBanner(this.companySettingsData.idCompany);
          }
          if (this.companySettingsData?.tpaCompanyId == '1666') {
            this.isCHLA = true;
            this.getProductsTempShoppingCart();
          }
        }
      }
    );
  }
  getCompanyLogo(idCompany: number, idTpa: number): void {
    this.companySubscription = this.companyService
      .getTPACompanyLogo(idCompany, idTpa)
      .subscribe((res: CompanyLogoDTO) => {
        if (res) {
          if (res.logo) {
            this.logoUrl = 'data:image/png;base64, ' + res.logo;
          } else {
            this.logoUrl = 'assets/images/edenred_logo_new.svg';
          }
        } else {
          this.logoUrl = 'assets/images/edenred_logo_new.svg';
        }
      });
  }
  getMemberSettings() {
    this.memberSubscription = this.memberService.member$.subscribe(memberDetails => {
      if (memberDetails) {
        this.memberSettings = memberDetails;
        if (this.memberSettings?.isSuspended) {
          this.pptIsSuspended = true;
        }
        if (this.memberSettings?.isBlueBadgeEmployee) {
          this.isBlueBadgeEmp = true;
        }
        if (this.memberSettings?.hadOrders) {
          this.hadOrders = true;
        }
        if (this.memberSettings?.hadClaims) {
          this.hadClaims = true;
        }
        this.getCompanySettingsData();
      }
    });
  }

  //ToDo:- If we need to check the had orders flag also in future for the elect benefits page.
  get allowAmazonElectBenefit(): boolean {
    if (this.companySettingsData?.tpaCompanyId !== TpaCompanyId.Amazon) {
      return true;
    }

    const amazonEligibility = AppUtils.getAmazonEligibilityContext(this.memberSettings, this.companySettingsData);

    if (!amazonEligibility.hasAnyAmazonEligibleBenefit || !amazonEligibility.isBlueBadge) {
      return this.hadOrders;
    }

    return true;
  }

  get showCardTab(): boolean {
    return (
      (this.isTrnPrkPCCCAllow && (!this.isAmznDiffLocation || this.hasActiveCard) && !this.isOrcaRole) || this.isCHLA
    );
  }

  loadContactInfo = (): void => {
    this.memberSubscription = this.memberService.member$?.subscribe(userInfo => {
      if (userInfo) {
        this.memberContact = userInfo?.memberContact;
        this.fullName = userInfo?.memberContact?.preferredFirstName
          ? (
              userInfo?.memberContact?.preferredFirstName +
              ' ' +
              (userInfo?.memberContact?.preferredLastName || '')
            ).trim()
          : this.authService.getFullname();
      }
    });
  };
  getProductsTempShoppingCart(): void {
    this.shoppingCartSubscription = this.shoppingCartService.tempShoppingCartDetails$.subscribe(
      (tempCart: CartDetailDTO[]) => {
        if (tempCart && tempCart.length > 0) {
          tempCart.forEach(tc => {
            let noMBBProducts = tc.products.filter(product => product.idOrderType !== OrderTypeEnum.MBB);
            if (this.isCHLA) {
              this.cartProductsCount = noMBBProducts.length;
            }
            return;
          });
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
    if (this.cardSubscription) {
      this.cardSubscription.unsubscribe();
    }
    if (this.shoppingCartSubscription) {
      this.shoppingCartSubscription.unsubscribe();
    }
    if (this.memberSubscription) {
      this.memberSubscription.unsubscribe();
    }
  }
  navigateToReviewOrder(): void {
    this.router.navigateByUrl('/elect-benefits/review-order');
  }
}
